  <template>
    <v-container fill-height class="mainBackG h-100 loginMain">
      <v-layout row wrap>
        <v-flex class="text-xs-center" xs12 sm12 md12 lg4 style="margin:auto">
          <div class="Formcard pb-5 card-r no-shadow">
            <div class="card-r mb-5 no-shadow w-100">
            <v-flex class="pt-1 mt-5 pt-4">
              <!--<h1 class="f-45 font-weight-bold">Hey Way</h1>-->
              <!--<div class="f-15">Admin Login</div>-->
              <img class="logo" src="/static/logo3.png">
            </v-flex>
            <v-form v-model="loginAdmin" row  @submit.prevent="login" class="w-100">
              <v-container xs12 md12 class="pa-0 mt-4">
                <v-layout wrap class="logBD">

                  <!-- <v-flex xs12 sm12>
                  <v-alert
                    :value="true"
                    color="error"
                    icon="warning"
                    outline
                    v-if=error
                  >
                    {{text}}
                  </v-alert>
                  </v-flex> -->
                  <v-flex xs12 sm12>

                    <v-text-field
                      v-model="email"
                      solo
                      label="Email"
                      :role="emailRules"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 pb-0>
                    <v-text-field
                      solo
                      v-model="password"
                      label="Password"
                      :type="passwordShow ? 'text' : 'password'"
                      :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                      @click:append="passwordShow = !passwordShow"
                      :role="passwordRule"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 pb-0 class="display-grid pa-0" >
                    <v-btn class="text-white h-50p mainBackG card-r shadow-1" color="white" type="submit">Login</v-btn>
                  </v-flex>
                        <v-flex xs6 md6 class="text-xs-left" py-0>
                          <router-link to="/resetpassword" class="aBtn text-xs-right">Reset your password</router-link>
                        </v-flex>
                        <v-flex xs6 md6 class="text-xs-right" py-0>
                          <router-link to="/signup" class="aBtn text-xs-right">Register Now</router-link>
                        </v-flex>
                  <!-- <v-flex xs12 lg12 class="title pa-4" py-0>
                    <a href="/signup" class="btn btn-xs btn-primary btn-block">Register Now</a>
                  </v-flex> -->

                </v-layout>
              </v-container>
            </v-form>
             <v-snackbar v-if="error" :top="true" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="error">
                  {{ text }}
                  <v-btn class="pink--text" flat @click.native="error = false">Close</v-btn>
            </v-snackbar>
            <v-snackbar v-if="loading" :top="true" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="timeout">
                  {{ text1 }}

            </v-snackbar>
          </div>
          </div>
        </v-flex>
      </v-layout>
      <!-- <notifications group="error" position="top center"/> -->
    </v-container>
</template>

  <script>
/* eslint-disable */
import auth from '../../utils/auth'
import router from '@/router'

export default {
  name: "Login",
  data: () => ({
    loginAdmin: true,
    email: "",
    password: "",
    passwordShow: false,
    error: false,
    loading:false,
    text: '',
    mode: '',
    timeout: 6000,

    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    passwordRule: [
      v => !!v || "Password is required",
      v => v.length >= 8 || "Password must be more than 8 characters"
    ]
  }),
  validations:{
    // email:{
    //   required,
    // }
  },
  methods: {
    login() {
      let data = {
        email: this.email,
        password: this.password
      };
        auth.login(data, (loggedIn, err) => {
        if (err) {
          this.error = true
          this.text = "You have entered an invalid username or password"
        } else if (loggedIn === false) {
          this.error = true
          this.text = 'You have entered an invalid username or password'
        } else if(loggedIn === true) {
          this.text1='Loading....'
          //this.$router.push(this.$route.query.redirect || '/')
           router.push('/')
           //user.email_verify

        }
      })
      // setTimeout(() => {
      //   this.error = true
      //   this.text = 'You have entered an invalid username or password'
      // }, 3000);
    },


  },
  computed:{
  }
};
</script>
  <style>
    .align{
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
    }
    .Formcard{
      height: -webkit-fill-available!important;
    }
  </style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue